import { BenefitType } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

import { PlanBadge } from '../PlanBadge';

const getBenefitTypeBadgeConfig = (
  benefitType: BenefitType | null | undefined
) =>
  $enum.mapValue(benefitType).with({
    [BenefitType.MAJOR_MEDICAL]: {
      label: 'Medical',
      tooltipLabel: 'This is a medical plan',
    },
    [BenefitType.SUPPLEMENTAL_DENTAL]: {
      label: 'Dental',
      tooltipLabel: 'This is a dental plan',
    },
    [BenefitType.SUPPLEMENTAL_VISION]: {
      label: 'Vision',
      tooltipLabel: 'This is a vision plan',
    },
    [BenefitType.SUPPLEMENTAL_COMBINED_DENTAL_VISION]: {
      label: 'Dental & Vision',
      tooltipLabel: 'This is a dental & vision plan',
    },
    [BenefitType.SUPPLEMENTAL_ACCIDENT]: undefined,
    [BenefitType.SUPPLEMENTAL_ACCIDENTAL_DEATH_AND_DISMEMBERMENT]: undefined,
    [BenefitType.SUPPLEMENTAL_CRITICAL_ILLNESS]: undefined,
    [BenefitType.SUPPLEMENTAL_FLEXIBLE_SPENDING_ACCOUNT]: undefined,
    [BenefitType.SUPPLEMENTAL_HOSPITAL]: undefined,
    [BenefitType.SUPPLEMENTAL_LIFE]: undefined,
    [BenefitType.SUPPLEMENTAL_OTHER]: undefined,
    [$enum.handleUndefined]: undefined,
    [$enum.handleNull]: undefined,
  });

type Props = {
  benefitType?: BenefitType | null;
};

export const BenefitTypeBadge = ({ benefitType }: Props) => {
  const badgeConfig = getBenefitTypeBadgeConfig(benefitType);
  if (!badgeConfig) {
    return null;
  }

  return (
    <PlanBadge
      tooltipLabel={badgeConfig.tooltipLabel}
      label={badgeConfig.label}
      size="sm"
    />
  );
};
